import { CSSProperties, KeyboardEvent, MouseEvent as ReactMouseEvent } from 'react';

export interface NativeProps {
  id?: string;
  class?: string;
  testSelector?: string;
  onClick?: (...args: any[]) => (Promise<void> | void);
  onKeyUp?: (event: KeyboardEvent) => (Promise<void> | void);
  onKeyDown?: (event: KeyboardEvent) => (Promise<void> | void);
  style?: CSSProperties;
}

export enum CSpacing {
  Xxlg = 'xxlg',
  Xlg = 'xlg',
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xs = 'xs',
  Xxs = 'xxs',
  None = 'none',
}

export enum CBorderRadius {
  None = 'none',
  Sm = 'sm',
  Md = 'md',
  Lg = 'lg',
  Round = 'round',
}

export enum CSeverity {
  Info = 'info',
  Success = 'success',
  Error = 'error',
  Warning = 'warning',
}
